export const formatDecimal = (
  num: number | null | undefined,
  digits = 2,
): string => {
  if (typeof num !== `number`) {
    return `-`
  }

  return Intl.NumberFormat(`en-US`, {
    style: `decimal`,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(num)
}

export const formatInteger = (num: number | null | undefined): string => {
  if (typeof num !== `number`) {
    return `-`
  }

  if (num < 1 && num > -1) {
    num = 0
  }

  return Intl.NumberFormat(`en-US`, { maximumFractionDigits: 0 }).format(num)
}

export const formatCurrency = (
  num: number | null | undefined,
  options: Intl.NumberFormatOptions = {},
): string => {
  if (typeof num !== `number`) {
    return `$-`
  }

  return Intl.NumberFormat(`en-US`, {
    style: `currency`,
    currency: `USD`,
    ...options,
  }).format(num)
}

export const parseCurrency = (formattedString: string): number | null => {
  const numericString = formattedString.replace(/[^0-9.-]+/g, ``)
  const parsedNumber = parseFloat(numericString)
  if (isNaN(parsedNumber)) {
    return null
  }

  return parsedNumber
}

// providerMeta.escalatorRate is a number for Goodleap (2.99) but EnFin
// persists the raw provider string ("2.99%"); normalize both to a number, or
// null when missing/unparseable so display sites can omit the rate instead of
// asserting a false 0%.
export const parseEscalatorRate = (value: unknown): number | null => {
  if (typeof value === `number`) {
    return Number.isFinite(value) ? value : null
  }

  if (typeof value === `string`) {
    const normalized = value.trim().replace(`%`, ``)
    if (normalized === ``) {
      return null
    }
    const parsed = Number(normalized)

    return Number.isFinite(parsed) ? parsed : null
  }

  return null
}

export const formatPercent = (num: number | null | undefined): string => {
  if (typeof num !== `number`) {
    return `-`
  }

  return Intl.NumberFormat(`en-US`, {
    style: `percent`,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num)
}
